// extracted by mini-css-extract-plugin
module.exports = {"container":"text_container__Zi_t8","filter":"text_filter__S9q1m","animatedLabel":"text_animatedLabel___JD_D","focus":"text_focus__KuwZG","inputField":"text_inputField__74CP3"};